import { render, staticRenderFns } from "./FormaTrabalho.vue?vue&type=template&id=94bb5610&scoped=true"
import script from "./FormaTrabalho.vue?vue&type=script&lang=js"
export * from "./FormaTrabalho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bb5610",
  null
  
)

export default component.exports